import { IframeMsgHandler } from './IframeMsgHandler'

export class IframeMsgConnecter {
  #handler = null
  constructor () {
    this.#handler = new IframeMsgHandler(this)
    window.addEventListener('message', this.onReceiveMsg.bind(this))
    this.connect()
  }

  setApp (app) {
    if (this.#handler) {
      this.#handler.setApp(app)
    }
  }

  connect () {
    const sendData = {
      type: 'connected'
    }
    this.postMessage(sendData)
  }

  postMessage (data) {
    window.top.postMessage(JSON.stringify(data), '*')
  }

  onReceiveMsg (event) {
    // if (event.origin === window.location.origin) {
    //   return
    // }

    let receiveData
    try {
      const data = JSON.parse(event.data)
      if (data && data.type) {
        receiveData = data
      }
    } catch {
    }
    if (receiveData) {
      this.#handler.dispatchMessage(event, receiveData)
    }
  }

  destroy () {
    window.removeEventListener('message', this.onReceiveMsg.bind(this))
  }
}
